import { FC, memo } from 'react'
import Page from 'components/Page'
import { StickyPanelFrame } from 'components/Page/StickyPanelFrame'
import { Button, IconPlus } from '@sequencehq/core-components'
import { ProtectedButton } from 'lib/rbac'
import { UsageMetricsMagicTable } from './UsageMetricsMagicTable'
import { Provider, useAtom } from 'jotai'
import { showCreateUsageMetricDrawerAtom } from './usageMetrics.atoms'
import { Outlet } from 'react-router-dom'
import { CreateUsageMetricDrawer } from '../../components/modals/CreateUsageMetricDrawer'

const UsageMetricsBase: FC = memo(() => {
  const [showCreateUsageMetricDrawer, setShowCreateUsageMetricDrawer] = useAtom(
    showCreateUsageMetricDrawerAtom
  )

  return (
    <>
      {showCreateUsageMetricDrawer && (
        <CreateUsageMetricDrawer
          onClose={() => setShowCreateUsageMetricDrawer(false)}
        />
      )}
      <StickyPanelFrame>
        <Page
          title="Metrics"
          addNewConfig={{
            button: (
              <ProtectedButton permission="org.usage:create">
                <Button
                  variant="primary"
                  leadingIcon={<IconPlus color="inherit" />}
                  onClick={() => setShowCreateUsageMetricDrawer(true)}
                  data-testid="usageMetrics.header.newMetric"
                >
                  New usage metric
                </Button>
              </ProtectedButton>
            )
          }}
          paddingBottom={0}
        >
          <UsageMetricsMagicTable />
        </Page>
      </StickyPanelFrame>
      <Outlet />
    </>
  )
})

export const UsageMetrics = () => {
  return (
    <Provider>
      <UsageMetricsBase />
    </Provider>
  )
}
